import { render, staticRenderFns } from "./top-courses.vue?vue&type=template&id=ab7b4502"
import script from "./top-courses.vue?vue&type=script&lang=js"
export * from "./top-courses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports